import {FilterMap, ProductFilter} from "../models/filter";
import {QueryController} from "../services/query-controller";
import {FilterType, Gender, Product, Variant} from "../models/product";
import {filterService} from "../services/filter-service";
import {AppState} from "./store";
import {customerService} from "../services/customer-service";
import {Like} from "../models/customer";
import {QueryState} from "../models/query";
import {NY_Tracker, TrackingEvent} from "../services/tracking-service";
import {productService} from "../services/product-service";

let queryController;

const actions = () => ({
  toggleIsFilterDisplayed: (state: AppState, show?: boolean) => {
    const newState: boolean = show !== undefined ? show : !state.isFilterDisplayed;

    //disables scrolling the background when the list-filter is open
    // document.body.style.overflow = newState ? 'hidden' : 'visible';
    // document.body.style.height = newState ? '100%' : 'auto';
    document.documentElement.style.overflow = newState ? 'hidden' : 'visible';
    document.documentElement.style.height = newState ? '100%' : 'auto';
    return {isFilterDisplayed: newState}
  },

  toggleIsFilterModalDisplayed: (state: AppState, show?: boolean) => {
    const newState: boolean = show !== undefined ? show : !state.isFilterModalDisplayed;
    return {isFilterModalDisplayed: newState}
  },

  setDesktopColumnCount: (state, count: number) => {
    let event = {
      label: `${state.filters.gender} - DesktopColumnCount`,
      action: `SelectColumnCount: ${count}`,
      category: 'Products'
    };

    NY_Tracker.trackClick(event as TrackingEvent);

    return {desktopColumnCount: count}
  },

  async initStore(state: AppState, filterMap: FilterMap) {
    queryController = new QueryController(filterMap, state.products);

    if (!state.initialized) {
      state.products = await queryController.doQuery(true);
      state.initialized = true;
      state.lastScrollPosition = 0;
    } else if (state.filters.country !== filterMap.country) {
      queryController.filterMap = filterMap;
      state.lastScrollPosition = 0;
      state.products = await queryController.doQuery(true);
    }

    let products: Product[] = [];
    state.products.items.forEach(product => {
      products.push(new Product(product));
    });
    let queryState = new QueryState(state.products.totalCount, products, state.products.limit, state.products.offset);

    return {
      filters: filterMap,
      products: queryState,
      initialized: state.initialized,
    };
  },

  async updateStore(state: AppState, filterMap: FilterMap) {
    queryController = new QueryController(filterMap, state.products);

    state.products = await queryController.doQuery(true);
    state.initialized = true;
    state.lastScrollPosition = 0;

    let products: Product[] = [];
    state.products.items.forEach(product => {
      products.push(new Product(product));
    });
    let queryState = new QueryState(state.products.totalCount, products, state.products.limit, state.products.offset);

    return {
      filters: filterMap,
      products: queryState,
      initialized: state.initialized,
    };
  },

  resetStore() {
    return new AppState();
  },

  async setGender(state: AppState, gender: Gender) {
    const filterMap: FilterMap = await filterService.createFilterMap(gender);
    const result = await queryController.applyFilters(filterMap);

    filterService.updateUrlSearchParams(filterMap);
    return {
      filters: filterMap,
      products: result
    }
  },

  async clearAllFilters(state: AppState) {
    const filterMap = state.filters.clone();
    filterMap.clearAll();
    const result = await queryController.applyFilters(filterMap);
    filterService.updateUrlSearchParams(filterMap);
    return {
      filters: filterMap,
      products: result
    }
  },

  async toggleFilter(state: AppState, filter: ProductFilter) {
    const filterMap = state.filters.clone();
    filterMap.toggleFilter(filter);
    const result = await queryController.applyFilters(filterMap);
    filterService.updateUrlSearchParams(filterMap);

    let eventLabel = `${state.filters.gender} - ${filterService.getTranslationKey(filter, state.filters.gender)}`;
    let event = {
      label: eventLabel,
      action: 'SelectFilter: ' + filter.type,
      category: 'Products'
    };

    NY_Tracker.trackClick(event as TrackingEvent);

    return {
      filters: filterMap,
      products: result
    }
  },

  async loadNext() {
    const result = await queryController.loadNext();
    return {
      products: result
    }
  },

  async setLikes(state: AppState, likes: Like[], products?: Product[]) {
    if (products) {
      likes.map(like => {
        like.product = products.find(p => p.variants.find(v => v.productId === like.productId))
      })
    }
    return {
      likes: likes
    }
  },

  async setScrollPosition(state: AppState, pos: number) {
    return {
      lastScrollPosition: pos
    }
  },
  openInterstitial: () => {
    return {isInterstitialOpen: true}
  },
  closeInterstitial: () => {
    return {isInterstitialOpen: false}
  },

  async toggleLike(state: AppState, variant: Variant, newLikeState: boolean, dimension: string) {
    let newState: any = {};

    if (!customerService.isLoggedIn) {
      customerService.setCachedVariant(variant);
      return {isInterstitialOpen: true}
    }
    try {
      await customerService.toggleLike(variant, newLikeState, dimension);

      let foundIndex = -1;
      for (let i = 0; i < state.likes.length; i++) {
        const like = state.likes[i];
        if (like.productId === variant.productId && like.variantId === variant.id) {
          foundIndex = i;
          break
        }
      }

      if (foundIndex === -1) {
        const likedProduct = await productService.loadProductById(variant.productId, state.filters.country);
        state.likes.push(new Like(variant.productId, variant.id, likedProduct))
      } else {
        state.likes.splice(foundIndex, 1);
      }

      newState.likes = [...state.likes];

      // update like cache after likes have changed
      customerService.setLikes(newState.likes);

    } catch (e) {
      console.warn('error while handling like', e);
    }


    //If like filter is selected and a product is disliked remove the product from the products
    const likeFilter = state.filters.selected.find(it => it.type == FilterType.Like);
    if (likeFilter) {
      newState.products = await productService.loadProductsForLikes(newState.likes, state.filters.country);
    }

    return newState
  },

});

export default actions;
